import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import metadata from '../data/blogMetadata.json';
import { getLocaleFromPathname, withLocale } from '../lib/locale';
import './LatestUpdates.css';

export default function LatestUpdates() {
    const locale = getLocaleFromPathname(useLocation().pathname);
    const index = locale === 'en-US' ? 1 : 0;
    const t = (pt, en) => index ? en : pt;
    const categories = [
        ['release', t('Novidades Zild', 'Zild updates')],
        ['news', t('Radar IA', 'AI radar')],
        ['guide', t('Guias práticos', 'Practical guides')],
    ];
    const latest = [...metadata].sort((a, b) => (b.eventDate || '').localeCompare(a.eventDate || ''));
    return <section className="zild-latest-updates">
        <div className="zild-container">
            <div className="zild-latest-updates__heading">
                <div><span>BLOG ZILD</span><h2>{t('Acompanhe o próximo passo da IA.', 'Follow the next step in AI.')}</h2></div>
                <Link to={withLocale('/blog', locale)}>{t('Explorar o Blog', 'Explore the Blog')} <ArrowRight size={16} aria-hidden="true" /></Link>
            </div>
            <div className="zild-latest-updates__grid">
                {categories.map(([category, label]) => {
                    const post = latest.find(item => item.category === category);
                    if (!post) return null;
                    return <article key={category}>
                        <span>{label}</span>
                        <h3><Link to={withLocale(`/blog/${post.slug}`, locale)}>{post.title[index]}</Link></h3>
                        <p>{post.excerpt[index]}</p>
                        <Link className="zild-latest-updates__read" to={withLocale(`/blog/${post.slug}`, locale)} aria-label={`${t('Ler artigo', 'Read article')}: ${post.title[index]}`}>
                            {t('Ler artigo', 'Read article')} <ArrowRight size={15} aria-hidden="true" />
                        </Link>
                    </article>;
                })}
            </div>
        </div>
    </section>;
}
